import { useLookupFondsQuery } from "../../stores/OkOkStore";
import type { Demande } from "../../types/Demande";
import type { Fond } from "../../types/Fond";
import type { SelectProps } from "../../types/Interface";
import { uniqid } from "../../tools/utils";
import { useTrads } from "../../contexts/trads/useTrads";
import React from "react";

interface FondPlus  {
    demande:Demande
}

type SelectFondProps= SelectProps & FondPlus;
export function FondSelectorBootStrap({name, label, registerOutput, errors,demande}:SelectFondProps){
    const id=uniqid(name);
    const params:Record<string, string>={};
    const {translate}=useTrads();
    
    params['r[year]']=demande.year.toString();
    params['r[beneficiaire]']=demande.id_inscription.toString();
    
    const { data:fonds, error, isLoading } = useLookupFondsQuery(params);


    const fondInDispo = function(fond:Fond,demande:Demande) :boolean{
        if(fond.year!=demande.year){
            return true;
        }

        if( demande.montant > fond.solde){
            return true;
        }
        return false;
    }

    return (
            error ? (
               <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : fonds ? (
            <div className={"input-group " + (errors[name]?"has-validation":'')}>
            <div className={ "form-floating " +  (errors[name] ? " is-invalid":'')}>
            
                <select  id={id}
                    className={"form-select "+ (errors[name]? " is-invalid":'')} 
                    {...registerOutput} 
                >
                    <option value="0">-----</option>
                    {fonds.data.map((fond:Fond) => (
                        <option key={fond.id} value={fond.id} disabled={fondInDispo(fond,demande)}> 
                            {fond.name} {fond.solde}€ 
                        </option>
                    ))}
                </select>
                <label className="form-label" htmlFor={id}>{label}</label>
                {errors[name] && <div className="invalid-feedback">{errors[name].message as string}</div>}
            </div>
            </div>
        ):null
    );

}

interface UserFondPlus  {
    year: number,
    user_id:number
}

type SelectUserFondProps= SelectProps & UserFondPlus;
export function UserFondSelectorBootStrap({name, label, registerOutput, errors,year,user_id}:SelectUserFondProps){
    const id=uniqid(name);
    const params:Record<string, string>={};
    
    params['r[year]']=year.toString();
    params['r[beneficiaire]']=user_id.toString();
    
    const { data:fonds, error, isLoading } = useLookupFondsQuery(params);
    const {translate}=useTrads();
   

    return (
            error ? (
               <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : fonds ? (
            <div className={"input-group " + (errors[name] ? "has-validation":'')}>
            <div className={ "form-floating " +  (errors[name] ? " is-invalid":'')}>
            
                <select  id={id}
                    className={"form-select "+ (errors[name]? " is-invalid":'')} 
                    {...registerOutput} 
                >
                    <option value="0">-----</option>
                    {fonds.data.map((fond:Fond) => (
                        <React.Fragment key={fond.id}>
                        {((fond.type_frais?.length??0)  > 0)?
                            <option key={fond.id} value={fond.id} > 
                                {fond.name} {fond.solde}€ 
                            </option>
                        :null}
                        </React.Fragment>
                    ))}
                </select>
                <label className="form-label" htmlFor={id}>{label}</label>
                {errors[name] && <div className="invalid-feedback">{errors[name].message as string}</div>}
            </div>
            </div>
        ):null
    );

}